import React, { Component } from 'react';
import { Redirect } from 'react-router';
import Api from '../../Util/API';
import _ from 'lodash';
import { message, Checkbox, DatePicker } from 'antd';
import UploadComponent from '../Util/Upload';
import moment from 'moment';

import 'react-day-picker/lib/style.css';
import './Create.css';
import Photo from '../Icons/Photo.svg';
import Privacy from '../Icons/Privacy.svg';
import PublicIllu from '../Icons/PublicIllu.svg';
import Loader from '../Icons/Loader';

class Create extends Component {

	constructor(props) {
	    super(props);
	    this.state = {
	    	selectedDay: null,
	    	privacy: null,
	    	dayPickerVisible:false,
	    	illustration:'',
	    	title:'',
	    	target:'',
	    	description:'',
	    	data:[],
	    	isLoading:false,
	    	legalAgreement:false
	    };
	    this.handleFileUploaded = this.handleFileUploaded.bind(this);
		this.handleDayClick = this.handleDayClick.bind(this);
	    this.handleSubmit = this.handleSubmit.bind(this);
	    this.inputChange = this.inputChange.bind(this);
	    this.privacyUpdate = this.privacyUpdate.bind(this);
	    this.legalAgreement = this.legalAgreement.bind(this);
	}

	handleFileUploaded(file){
		this.setState({
	    	illustration: file.response
	    })
	}

	inputChange(event){
		this.setState({
			[event.target.name]:event.target.value
		});
	}

	privacyUpdate(value){
		this.setState({
			privacy:value
		});
	}

	legalAgreement(e){
		this.setState({
			legalAgreement:e.target.checked
		});
	}

	handleDayClick(day, { selected }) {
		this.setState({
		  selectedDay: selected ? undefined : day,
		  dayPickerVisible: !this.state.dayPickerVisible
		});
	}

	handleSubmit(event) {
		event.preventDefault();
		if(this.state.privacy === null){
			message.warning("Don't forget to choose between a public and a private project!",4)
			return false
		}
		if((this.state.selectedDay === null || this.state.selectedDay === undefined) && this.state.project_end_at === undefined){
			message.warning("Don't forget to set an ending date!",4)
			return false
		}
		this.setState({
	    	isLoading:true
	    })
		const data = {};
		let actions = this.props.actions;
		//SI PROPS MATCH PRESENT : ON EST SUR DE L EDITION
		if(this.props.match){
			data.privacy = this.state.privacy;
			data.project_end_at = this.state.selectedDay ? this.state.selectedDay : this.state.project_end_at;
			data.illustration = this.state.illustration;
			data.title = this.state.title;
			data.description = this.state.description;
			data.target = this.state.target;
			data.ending_date = moment(this.state.project_end_at).format('MMMM Do YYYY');
			data.project_id = this.props.match.params.id;
			Api.request('projects/' + data.project_id, 'POST', {data})
				.then((result) => {
					message.success('Project updated!');
					data.creator_name = this.props.currentUser.name;
					actions.editProject(data);
					this.setState({
						isLoading:false
					})
				});
	    //SINON CREATION
		}else{
			data.project_end_at = this.state.selectedDay;
			data.creator_email = this.props.currentUser.email;
			data.illustration = this.state.illustration;
			data.title = this.state.title;
			data.description = this.state.description;
			data.target = this.state.target;
			data.privacy = this.state.privacy;
			Api.request('projects/', 'POST', {data})
				.then((result) => {
					message.success('Project created!');
					data.project_id = result[0].id;
					data.creator_name = this.props.currentUser.name;
					actions.postProject(data);
					this.setState({
						isLoading:false
					})
				})
	            .catch(error => {
	                console.log(error);
	            });
		}

	}

	setCurrentRoute(){
		this.props.actions.setCurrentRoute('Create');
	}

	componentDidMount() {
		window.scrollTo(0, 0);
	    this.setCurrentRoute();
	    if(this.props.match){
			Api.request('projects/' + this.props.currentUser.email)
				.then(projects => {
					let currentProject = _.filter(projects, {project_id: this.props.match.params.id});
					let dataArray = currentProject[0];
					for (var key in dataArray) {
						this.setState({
					    	[key]:dataArray[key]
					    })
					}
				}); 
	    }
	}

	render() {

		console.log('legalAgreement : ',this.state.legalAgreement);
		const disabledDate = current => {
			// Can not select days before today and after next year
			let endOfYear = moment().endOf('year');
			let today = moment().endOf('day');
			return (current < today || current > endOfYear);
		}
		return (
			<div className="container">
				<div className="createContainer">
					<div className="createForm">
						<form onSubmit={this.handleSubmit}>
							<div className="pictureBloc">
								{ this.state.illustration !== '' &&
									<div className="backgroundPicture"><img className="pictureUrl" src={this.state.illustration ? this.state.illustration : this.state.illustration} alt="Your beautiful illustration here" /></div>
								}
								<div className="pictureBlocForm">
									<div className="pictureTitleHeader">
										<div className="pictureIcon"><img src={Photo} alt="Project's illustration" title="Project's illustration" /></div>
										<div className="pictureTitle">Your beautiful picture</div>
									</div>
									<div className="dropzone">
										<UploadComponent 
											data={this.state} 
											currentUser={this.props.currentUser} 
											handleFileUploaded={this.handleFileUploaded}
											message="Upload your image here (under 3MB)"
											type='illustration' />
									</div>
								</div>
							</div>
							<div className="contentBloc">
								<div className="lineBloc">
									<label htmlFor="title" className="label">Type of project<sup>*</sup></label>
									<div className={"privacyBloc public " + (this.state.privacy === 0 && "checked")} onClick={() => this.privacyUpdate(0)}>
										<div className="illustration"><img src={PublicIllu} alt="Public" title="Public" /></div>
										<input type="radio" name="public" value="0" checked={parseInt(this.state.privacy, 10) === 0} onChange={this.privacyChange} />
										<div className="label">Open</div>
										<div className="description">Everyone can see and fund "open projects"</div>
  									</div>
									<div className={"privacyBloc private " + (this.state.privacy === 1 && "checked")} onClick={() => this.privacyUpdate(1)}>
										<div className="illustration"><img src={Privacy} alt="Private" title="Private" /></div>
  										<input type="radio" name="privacy" value="1" checked={parseInt(this.state.privacy, 10) === 1} onChange={this.privacyChange} />
  										<div className="label">Closed</div>
										<div className="description">Only people who have been invited by the project creator<br/> can see and fund "closed projects"</div>
  									</div>
  								</div>
								<div className="lineBloc">
									<div className="titleBloc">
										<label htmlFor="title" className="label">Title<sup>*</sup></label>
										<input type="text" name="title" className="input" placeholder="Be inspiring" value={this.state.title} onChange={this.inputChange} required />
									</div>
									<div className="amountBloc">
										<label htmlFor="target" className="label">How much money do you need?<sup>*</sup></label>
										<input type="number" name="target" className="input" placeholder="€200" min="1" max="45000" step="0.01" value={this.state.target} onChange={this.inputChange} required />
									</div>
								</div>
								<div className="lineBloc">
									<div className="messageBloc">
										<label htmlFor="description" className="label">Message</label>
										<textarea name="description" className="input" placeholder="Tell us more about your project :)" value={this.state.description} onChange={this.inputChange}></textarea>
									</div>
								</div>
								<div className="lineBloc">
									<div className="dateBloc">
										<label className="label">When does it end?<sup>*</sup></label>
								        { this.state.project_end_at &&
								        	<DatePicker
										      format="DD/MM/YYYY"
										      placeholder="Please select a day"
										      onChange={this.handleDayClick}
										      disabledDate={disabledDate}
										      defaultValue={moment(this.state.project_end_at)}
									   		/>
									   	}
									   	{ !this.state.project_end_at &&
								        	<DatePicker
										      format="DD/MM/YYYY"
										      placeholder="Please select a day"
										      onChange={this.handleDayClick}
										      disabledDate={disabledDate}
									   		/>
									   	}
									</div>
								</div>
								{!this.props.match && <div className="lineBloc">
									<label className="label">Required agreement<sup>*</sup></label>
										<div className="agreementBloc">
											<Checkbox onChange={this.legalAgreement}>My project can’t be a gift for someone at iAdvize, or I can’t use my cagnotte for a send off party. I can’t use it for something only used by myself except if it’s iAdvize branded.</Checkbox>
										</div>
									</div>
								}
								<div className="mention">* Requested information</div>
								<div className="formValid">
									<button className={"button is-primary " + (!this.state.legalAgreement && !this.props.match ? 'disabled' : '')} disabled={this.state.isLoading || (!this.state.legalAgreement && !this.props.match)}>{this.state.isLoading ? <Loader color="#fff" /> : (this.props.match ? "Update" : "Back it on!")}</button>
								</div>
							</div>
						</form>
						{(this.props.formRedirect && this.props.match) ? (
				          <Redirect to={'/projects/' + this.props.match.params.id}/>
				        ) : ( this.props.formRedirect && this.props.match === undefined && this.state.privacy === 0 ? 
				          <Redirect to={'/'}/> : ( this.props.formRedirect && this.props.match === undefined && this.state.privacy === 1 ?
				          	<Redirect to={'/yourprojects'}/> : ''
				          )
				        )}
					</div>
				</div>
			</div>
		);
	}
}

export default Create;



// WEBPACK FOOTER //
// ./src/components/Create/Create.js